import { Box, Grid, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import HeaderToolbar from "../../components/HeaderToolbar";
import { getAssignedProducts } from "../../slices/ProductSlice/ProductSlice";

function DealerProducts() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [productsResponse, setProductsResponse] = useState([]);
  const [hardwareDevices, setHardwareDevices] = useState([]);
  const [accessoryDevices, setAccessoryDevices] = useState([]);

  useEffect(() => {
    loadProducts();
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const calculateInitialHeight = () => {
    return window.innerHeight - 150;
  };

  const [height, setHeight] = useState(calculateInitialHeight);
  const [initialWindowHeight, setInitialWindowHeight] = useState(
    window.innerHeight
  );

  useEffect(() => {
    const handleResize = () => {
      const percentageChange = (window.innerHeight / initialWindowHeight) * 100;

      setHeight(calculateInitialHeight);
      setInitialWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [initialWindowHeight]);

  const loadProducts = () => {
    dispatch(getAssignedProducts(localStorage.getItem("companyId")))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4000") {
          setProductsResponse(res.data);
          let hardWareDevices = res.data
            .filter((product) => product.productType === "HARDWARE")
            .map((product) => ({
              ...product,
              quantity: 0,
              frequency: "monthly",
            }));
          let accessoryDevices = res.data
            .filter((product) => product.productType === "ACCESSORY")
            .map((product) => ({
              ...product,
              quantity: 0,
            }));
          setHardwareDevices(hardWareDevices);
          setAccessoryDevices(accessoryDevices);
        }
      });
  };

  return (
    <>
      <Box
        sx={{
          padding: "8px",
          marginLeft: "1px",
        }}
      >
        <HeaderToolbar title={t("PRODUCT")} />
      </Box>

      <Box
        style={{
          padding: "0px",
          marginLeft: "8px",
          width: "100%",
          height: `${height}px`,
          overflowY: "auto",
          scrollbarWidth: "none",
          borderRadius: "10px",
        }}
      >
        <div
          style={{
            flexGrow: 1,
            overflowY: "auto",
            // maxHeight: "calc(100vh - 64px)",
            height: "100%",
            overflowX: "hidden",
          }}
        >
          <Grid
            style={{
              backgroundColor: "white",
              marginTop: "10px",
            }}
            spacing={2}
          >
            {hardwareDevices.length > 0 && (
              <Grid container spacing={2} padding={2}>
                <Grid item xs={12}>
                  <Typography
                    style={{
                      color: "#474A4E",
                      fontSize: "20px",
                      fontFamily: "font_semiBold",
                    }}
                  >
                    {t("HARDWARE")}
                  </Typography>
                </Grid>
                {hardwareDevices.map((product, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Box
                      position="relative"
                      style={{
                        height: "150px",
                        backgroundColor: "#F9F9F9",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "12px",
                      }}
                    >
                      <Box
                        style={{
                          height: "92px",
                          width: "92px",
                          backgroundColor: "#D8D8D8",
                          borderRadius: "12px",
                        }}
                      >
                        <img
                          src={product.productImagePresignedUrl}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "12px",
                          }}
                        />
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        overflow: "hidden",
                        wordWrap: "break-word",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Typography
                        style={{
                          color: "#474A4E",
                          fontSize: "18px",
                          fontFamily: "font_bold",
                          whiteSpace: "normal",
                          wordBreak: "break-word", // Ensures long words break to the next line
                          overflowWrap: "break-word", // Prevents text overflow
                          textOverflow: "ellipsis", // Adds ellipsis for overflowed text
                          display: "-webkit-box",
                          WebkitLineClamp: 1, // Limits the number of lines to 2
                          WebkitBoxOrient: "vertical",
                          maxWidth: "100%", // Ensures it does not exceed the container
                          overflow: "hidden",
                        }}
                      >
                        <Tooltip
                          title={
                            product.productModel
                              ? product.productName + "+" + product.productModel
                              : product.productName
                          }
                          placement="bottom-start"
                        >
                          {product.productModel
                            ? product.productName + "+" + product.productModel
                            : product.productName}
                        </Tooltip>
                      </Typography>
                      <Typography
                        style={{
                          color: "#226BAB",
                          fontSize: "16px",
                          fontFamily: "font_semiBold",
                        }}
                      >
                        Monthly - ${product.monthlyPrice} / Onetime - $
                        {product.oneTimePrice}
                      </Typography>
                      <Tooltip title={product.description}>
                        <Typography
                          style={{
                            color: "#474A4E",
                            fontSize: "14px",
                            fontFamily: "font_regular",
                            whiteSpace: "normal",
                            wordBreak: "break-word", // Ensures long words break to the next line
                            overflowWrap: "break-word", // Prevents overflow
                            textOverflow: "ellipsis", // Adds ellipsis for overflowed text
                            display: "-webkit-box",
                            WebkitLineClamp: 3, // Limits the number of lines
                            WebkitBoxOrient: "vertical",
                            maxWidth: "100%", // Prevents width overflow
                          }}
                        >
                          {product.description}
                        </Typography>
                      </Tooltip>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            )}

            {/* Accessory Section */}
            {accessoryDevices.length > 0 && (
              <Grid container spacing={2} padding={2}>
                <Grid item xs={12}>
                  <Typography
                    style={{
                      color: "#474A4E",
                      fontSize: "20px",
                      fontFamily: "font_semiBold",
                    }}
                  >
                    {t("ACCESSORIES")}
                  </Typography>
                </Grid>
                {accessoryDevices.map((product, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Box
                      position="relative"
                      style={{
                        height: "150px",
                        backgroundColor: "#F9F9F9",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "12px",
                      }}
                    >
                      <Box
                        style={{
                          height: "92px",
                          width: "92px",
                          backgroundColor: "#D8D8D8",
                          borderRadius: "12px",
                        }}
                      >
                        <img
                          src={product.productImagePresignedUrl}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "12px",
                          }}
                        />
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        overflow: "hidden",
                        wordWrap: "break-word",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Typography
                        style={{
                          color: "#474A4E",
                          fontSize: "18px",
                          fontFamily: "font_bold",
                          whiteSpace: "normal",
                          wordBreak: "break-word", // Ensures long words break to the next line
                          overflowWrap: "break-word", // Prevents text overflow
                          textOverflow: "ellipsis", // Adds ellipsis for overflowed text
                          display: "-webkit-box",
                          WebkitLineClamp: 1, // Limits the number of lines to 2
                          WebkitBoxOrient: "vertical",
                          maxWidth: "100%", // Ensures it does not exceed the container
                          overflow: "hidden",
                        }}
                      >
                        <Tooltip
                          title={
                            product.productModel
                              ? product.productName + "+" + product.productModel
                              : product.productName
                          }
                          placement="bottom-start"
                        >
                          {product.productModel
                            ? product.productName + "+" + product.productModel
                            : product.productName}
                        </Tooltip>
                      </Typography>
                      <Typography
                        style={{
                          color: "#226BAB",
                          fontSize: "16px",
                          fontFamily: "font_semiBold",
                        }}
                      >
                        Monthly - ${product.monthlyPrice} / Onetime - $
                        {product.oneTimePrice}
                      </Typography>
                      <Tooltip title={product.description}>
                        <Typography
                          style={{
                            color: "#474A4E",
                            fontSize: "14px",
                            fontFamily: "font_regular",
                            whiteSpace: "normal",
                            wordBreak: "break-word", // Ensures long words break to the next line
                            overflowWrap: "break-word", // Prevents overflow
                            textOverflow: "ellipsis", // Adds ellipsis for overflowed text
                            display: "-webkit-box",
                            WebkitLineClamp: 3, // Limits the number of lines
                            WebkitBoxOrient: "vertical",
                            maxWidth: "100%", // Prevents width overflow
                          }}
                        >
                          {product.description}
                        </Typography>
                      </Tooltip>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            )}
          </Grid>
        </div>
      </Box>
    </>
  );
}

export default DealerProducts;
